import ManageManufacturingFacilitiesModalContent from "./Content";

export default ManageManufacturingFacilitiesModalContent;
